var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnexLogoDarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 707.1 120",
    style: {
      enableBackground: "new 0 0 707.1 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E04E38;}\n\t.st2{display:none;}\n\t.st3{display:inline;}\n\t.st4{fill:#ED5338;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.5,60c0-34.3,25.3-58,60.9-58s60.9,24,60.9,58s-25.3,58-60.9,58C128.5,118,103.5,94.3,103.5,60z M189.4,60 c0-16.9-9.8-28.2-25-28.2c-15,0-25,11.3-25,28.2s10,28.2,25,28.2C179.4,88.2,189.4,76.9,189.4,60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339.6,45.2v66.3c0,1.5-1.3,2.8-2.8,2.8h-32.5V51c0-11.3-4-17.9-14-17.9c-12.7,0-20,9-20,20.8v57.6 c0,1.5-1.3,2.8-2.8,2.8h-32.5V5.4h9.9c7.9,0,15,4.7,18.1,12l2.1,4.9C271.8,11.8,282.9,2,301.1,2C326.2,2,339.6,18.1,339.6,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M576.1,56c0,3.8-0.2,7.9-0.7,12.1c-0.2,1.4-1.4,2.4-2.8,2.4l-66.4,0c-2,0-3.4,2-2.6,3.8 c4.6,11,14.8,17,29.8,17c9.8,0,18.1-2.6,23.8-6.5c1.4-0.9,3.3-0.5,4.1,0.9l9.3,17c0.7,1.3,0.3,2.9-1,3.7 c-12.2,7.5-24.4,11.5-41,11.5c-36.6,0-61.2-23.7-61.2-58c0-33.2,24.3-58,58.3-58C556.9,2,576.1,22.8,576.1,56z M505.3,50l36.4,0 c1.7,0,3-1.5,2.8-3.1c-1.6-12.9-9.8-18.8-19.8-18.8c-10.1,0-18.7,6.2-22.1,18.3C502.1,48.2,503.4,50,505.3,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.7,80c-7,5.7-13.7,8.2-23,8.2c-14.5,0-26.9-9.8-26.9-28.2c0-18.2,12.4-28.7,27.7-28.7 c8.9,0,15.7,2.3,22.5,8c3.2-9,8.5-16.7,15.5-22.8C92.7,7.2,79.1,2,61.3,2C28.4,2,2,24.4,2,59.7C2,98,31,118,60.5,118 c18.4,0,30.4-4.4,42.7-14.7C96.1,97.2,90.8,89.2,87.7,80z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.4,54.6l35.9-48.1c1.4-1.8,0.1-4.5-2.2-4.5h-21.2h-10.5c-0.9,0-1.7,0.4-2.3,1.1l-19.9,27l0,0l-20.2,27.5 l0,0l-38.5,52.2c-1.4,1.9,0,4.5,2.3,4.5h32.4c1,0,1.8-0.5,2.4-1.3l17.2-26.9c1.1-1.7,3.5-1.7,4.6-0.1l19.5,27.2 c0.5,0.7,1.4,1.2,2.3,1.2h33.6c2.3,0,3.6-2.6,2.3-4.4l-37.6-51.9C662.6,56.9,662.6,55.6,663.4,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621.4,2h-32.9c-2.3,0-3.6,2.6-2.3,4.4L611.8,42c1.1,1.6,3.4,1.6,4.5,0l16.6-22.9c0.7-1,0.7-2.3,0-3.3 l-9.2-12.7C623.1,2.4,622.3,2,621.4,2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.6,45.2v66.3c0,1.5-1.3,2.8-2.8,2.8h-32.5V51c0-11.3-4-17.9-14-17.9c-12.7,0-20,9-20,20.8v57.6 c0,1.5-1.3,2.8-2.8,2.8h-32.5V5.4h9.9c7.9,0,15,4.7,18.1,12l2.1,4.9C389.8,11.8,400.9,2,419.1,2C444.1,2,457.6,18.1,457.6,45.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "105,0.9 105,37.1 151.3,89.8 105,89.8 105,112.3 171.1,112.3 183.2,89.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "88.2,89.8 41.9,89.8 88.2,37.1 88.2,0.9 80.6,9.5 10,89.8 22.1,112.3 88.2,112.3  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnexLogoDarkTheme);
export default __webpack_public_path__ + "static/media/connex-logo-dark-theme.bda4609d129d4450bee582e6ab33a74b.svg";
export { ForwardRef as ReactComponent };